module.exports = __webpack_public_path__ + "img/cart-icon-empty.7876a0c9.png";